import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { ClaraLogo } from "./ClaraLogo";
import { useLang, usePath } from "../i18n";

export const Footer = () => {
  const { t } = useLang();
  const lp = usePath();
  return (
  <footer data-testid="site-footer" className="bg-clara-espresso text-clara-cream noise-overlay relative">
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
      <div className="grid lg:grid-cols-3 gap-12 border-b border-white/10 pb-16">
        <div>
          <div className="mb-4"><ClaraLogo variant="cream" className="h-12" /></div>
          <p className="text-clara-darkmuted text-sm max-w-xs leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="space-y-4">
          <p className="eyebrow text-clara-terracotta">{t.footer.contact}</p>
          <a href="mailto:marketing@tanputratama.co.id" className="flex items-center gap-3 text-sm text-clara-cream/90 hover:text-clara-terracotta transition-colors" data-testid="footer-email">
            <Mail className="w-4 h-4" strokeWidth={1.5} /> marketing@tanputratama.co.id
          </a>
          <div className="flex items-center gap-3 text-sm text-clara-cream/90">
            <Phone className="w-4 h-4" strokeWidth={1.5} /> +6221 826 10031 / +6221 825 1113
          </div>
          <div className="flex items-start gap-3 text-sm text-clara-cream/90 max-w-xs">
            <MapPin className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5} />
            Jl. Raya Narogong Pangkalan 2, Cikiwul, Bantargebang, Bekasi, Jawa Barat 17152, Indonesia
          </div>
        </div>

        <div className="space-y-4">
          <p className="eyebrow text-clara-terracotta">{t.footer.explore}</p>
          <div className="flex flex-col gap-2 text-sm">
            <Link to={lp("/about")} className="text-clara-cream/90 hover:text-clara-terracotta transition-colors">{t.footer.links.about}</Link>
            <Link to={lp("/grades")} className="text-clara-cream/90 hover:text-clara-terracotta transition-colors">{t.footer.links.products}</Link>
            <Link to={lp("/quality")} className="text-clara-cream/90 hover:text-clara-terracotta transition-colors">{t.footer.links.quality}</Link>
            <Link to={lp("/news")} className="text-clara-cream/90 hover:text-clara-terracotta transition-colors">{t.footer.links.news}</Link>
            <a href="/clara-catalogue.pdf" download data-testid="footer-catalogue-link" className="text-clara-cream/90 hover:text-clara-terracotta transition-colors">{t.catalogueCta}</a>
          </div>
          <div className="pt-2 font-data text-xs text-clara-darkmuted">www.claracocoa.co.id</div>
        </div>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-clara-darkmuted font-data">
        <span>© {new Date().getFullYear()} PT Tan Putra Tama. {t.footer.rights}</span>
        <span data-testid="footer-certs">{t.footer.certs}</span>
      </div>
    </div>
  </footer>
  );
};
